  <template>
  <app-modal
    v-model="isDialogOpened"
    size="md"
    :ok-text="$t('common.confirm')"
    :ok-loading="patchNumberingPending"
    :cancel-disabled="patchNumberingPending"
    data-locator="documents-disable-numbering-dialog"
    @ok="onConfirm"
    @cancel="closeDialog"
  >
    <template #title>{{ $t('project.documents.dialogs.DocumentsNumberingDisableDialog.title') }}</template>
    <template #body>
      <p>{{ $t('project.documents.dialogs.DocumentsNumberingDisableDialog.text') }}</p>
    </template>
  </app-modal>
</template>

<script>
import { mapState } from 'vuex'

import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'DocumentsNumberingDisableDialog',
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('documents', ['patchNumberingPending']),
  },
  methods: {
    async onConfirm () {
      this.$emit('confirm')
    },
  },
}
</script>
